import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { AddFileAttempt_ACTION, AddObjectAttempt_ACTION, GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';
import { CheckKeyboardAnswer, CreateChuck, getRandom, responsiveFontSize, responsiveHeight, responsiveWidth, SafeSimplify } from '../Services/Utilities';
import LatexViewComponent from './LatexViewComponent';
import AdvancedLatexComponent from './AdvancedLatexComponent';
import SafeLatexViewComponent from './SafeLatexViewComponent';

const NUMERIC_BLOCK = +8
const VARIABLE_BLOCK = +9
var typingTimer

class MultipleChoiceQuestionPlayComponent extends Component {
    constructor(props){
        super(props)
        this.first_line_ref = React.createRef()

        this.state = {
            Answers:[],
            AnswresStatus:[],
            Choices:[],
            CheckAnswer: false,
            ShowSolution: false,
            Id: -1,

            StartTime:0,
            FirstLineWidth: responsiveWidth(60),
            componentVisible:false
        }

        this.TopPart = this.TopPart.bind(this)
        this.AnswerStatusLine = this.AnswerStatusLine.bind(this)
        this.ChoiceBlock = this.ChoiceBlock.bind(this)
        this.ActionLine = this.ActionLine.bind(this)

        //
        this.NextAction = this.NextAction.bind(this)
        this.ClearAction = this.ClearAction.bind(this)
        this.CheckAnswerAction = this.CheckAnswerAction.bind(this)

    }

    componentDidMount(){
        this.setState({
            Id: this.props.Id
        })
        
        this.props.GetInfo(this.props.Id)
        typingTimer = setTimeout(() => {
            this.setState({
                FirstLineWidth:this.first_line_ref.current.offsetWidth,
                componentVisible: true
                })
        }, 100);
    }

    componentWillReceiveProps(nextprops){
        //GET QUESTION DATA
        if(nextprops.Id != this.state.Id){
            console.log("nextprops")

            this.props.GetInfo(nextprops.Id)
            this.setState({
                Id: nextprops.Id,
            })
            
            return
        }

        if(nextprops.InSeries && nextprops.Question && nextprops.Id == this.state.Id){
            this.props.Object.setState(prev => ({
                LoadedClickableQuestions:  [...prev.LoadedClickableQuestions, nextprops.Question]
            }))
           
        }
        
        if(nextprops.Id == this.state.Id && nextprops.Question  &&  nextprops.Question.Choices){
            let ElementIds = nextprops.Question.Choices.map((e) => e.Id)

            let RandomIds = getRandom(ElementIds, ElementIds.length)

            let RandomElements = RandomIds.map((Id) => {
                return nextprops.Question.Choices.filter((e) => e.Id == Id)[0]
            })

            this.setState({
                Id: nextprops.Id,
                Answers:nextprops.Question.Choices.map((c) => false),
                AnswresStatus:[],
                Choices: RandomElements,
                CheckAnswer: false,
                ShowSolution: false,
                StartTime: (new Date()).getTime()

            })
        }
    }

    render(){
        let ShowSolutions = true 
        if(this.props.Map){
            ShowSolutions = this.props.Map.ShowSolutions
        }

        let FirstLineWidth = this.state.FirstLineWidth

        return(
            <div
            ref = {this.first_line_ref}

            >
              {(this.props.IsQuestionSearching  || this.props.IsQuestionSearching == undefined || this.props.GetQuestionError || this.props.GetQuestionError == undefined) ? 
                      <SearchingTitleComponent error = {this.props.GetQuestionError}/>
                  : <div>
                     {this.TopPart()}
                    {this.ActionLine(ShowSolutions)}
                        
                     
                     <hr/>
                     
                     {this.state.CheckAnswer ? 
                     (this.AnswerStatusLine())
                     : <div/>}

                     {this.state.CheckAnswer ? 
                     <hr/> : <div/>}

                     <div style = {{height: responsiveHeight(50), overflowY:'scroll'}}>
                     {CreateChuck(this.state.Choices, this.props.Question.ChoicesPerRow).map((g,ii)=> (
                         <Row key = {ii} style = {{width:'100%', marginBottom: responsiveHeight(1)}}>
                            {g.map((c,i) => (
                                this.ChoiceBlock(c, 
                                    Math.floor(12/this.props.Question.ChoicesPerRow),
                                    ii*this.props.Question.ChoicesPerRow + i,
                                    ShowSolutions)))}
                            </Row>))}
                     </div>
                                        
                        
                  </div>
                  }
            </div>
        )
    }

    TopPart(){
        let FirstLineWidth = this.state.FirstLineWidth

        return(
            <div
            style = {{flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'space-between'}}>
                <div style = {{
                    flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center',
                    width:FirstLineWidth*0.23, marginLeft:0.01*FirstLineWidth, marginRight:0.01*FirstLineWidth, }}>
                        <img 
                        src = {this.props.Question.ImageURL}
                        style = {{width: FirstLineWidth*0.22,
                             height:FirstLineWidth*0.22,
                              objectFit:'contain'}}
                    />
                    
                </div>
                <div style = {{
                    flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center',
                    width:FirstLineWidth*0.75,  }}
                    >
                        <div style = {{height:FirstLineWidth*0.2, width:'100%', flexDirection:'row', display:'flex', overflowY:'scroll' }}>
                            <SafeLatexViewComponent
                            source={this.props.Question.Latex}
                            />

                        </div>
                        <div style = {{height:FirstLineWidth*0.025, width:'100%', flexDirection:'row', display:'flex' }}>
                            <h5 style = {{color:'#008fb3', fontSize: responsiveFontSize(0.7)}}>
                            {this.props.Question.AdditionalInfo}
                                </h5>

                        </div>
                        
                        
                    
                </div>
            </div>
        )
    }

    ActionLine(ShowSolutions){
        let FirstLineWidth = this.state.FirstLineWidth
        
        return(
            <div style = {{flexDirection:'row', display:'flex', marginTop: responsiveHeight(2)}}>
                <div style = {{width: FirstLineWidth*0.25}} />
                <div style = {{width: FirstLineWidth*0.75, flexDirection:'row', display:'flex'}}>
                {this.state.CheckAnswer && this.props.InSeries &&this.props.Object? 
                    <div
                    className ="square border border-primary"
                     style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                         flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                        onClick = {() => this.NextAction()}
                        >
                           <h5 style = {{color: '#0099cc', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                   Next
                                </h5>
                    </div>  :<div/>}

                {!this.state.CheckAnswer ? 
                    <div
                            className ="square border border-danger"
                             style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                                 flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                                onClick = {() => this.ClearAction()}
                                >
                                   <h5 style = {{color: 'red', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                            Clear
                                        </h5>
                            </div>: <div/>}


                {!this.state.CheckAnswer ? 
                   <div
                   className ="square border border-primary"
                    style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                        flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                       onClick = {() => this.CheckAnswerAction()}
                       >
                          <h5 style = {{color: '#0099cc', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                   Check answer
                               </h5>
                   </div> : <div/>}


                {this.state.CheckAnswer  && this.props.Question.PDFURL  && ShowSolutions? 
                   <div
                   className ="square border border-danger"
                    style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                        flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                       onClick = {() => {
                        window.open(this.props.Question.PDFURL)  

                        let data = new FormData()

                        data.append('QuestionId',this.props.Question.Id)
                        data.append('Player', this.props.Player)
                        data.append('Correct', this.state.AnswerStatus)

                        this.props.PostPDFStatistic(data)
                       }}
                       >
                          <h5 style = {{color: 'red', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                   PDF
                               </h5>
                   </div>
                    : <div/>}

                {this.state.CheckAnswer  && this.props.Question.VIDEOURL  && ShowSolutions? 
                   
                    <div
                    className ="square border border-primary"
                     style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                         flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}
 
                        onClick = {() =>{
                            window.open(this.props.Question.VIDEOURL)  
                        }}
                        >
                           <h5 style = {{color: '#0099cc', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                           Video
                            </h5>
                    </div>
                    : <div/>}

                {!this.state.CheckAnswer? 
                   <div
                   className ="square border border-success"
                    style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                        flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                       onClick = {() =>{
                        this.props.GetInfo(this.props.Id)                            
                    }}
                       >
                          <h5 style = {{color: 'green', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                          Reload question
                           </h5>
                   </div>
                   
                   : <div/>}
                </div>
            </div>
        )
    }

    NextAction(){

        if(this.props.Object.state.QuestionsAnswers.filter(a => !a.Answered).length )
        {
            this.props.Object.setState({
                CurrentIndex: this.props.Object.state.CurrentIndex + 1
            })

            return
        }

        this.props.Object.setState({
            ShowFinalScores: true
        })
    }

    ClearAction(){
        if(!this.state.CheckAnswer){
            this.setState({
                Answers:this.props.Question.Choices.map((c) => false)
            })
        }
    }

    CheckAnswerAction(){
        if(!this.state.Answers.includes(true)){
            alert("Please select atleast one answer")

            return
        }

        if(this.state.CheckAnswer)
        {
            return
        }

        let Correct = true  
        let CorrectAnswers = this.state.Choices.map((c) => c.Correct)
        let AnswresStatus = this.state.Choices.map((c,i) => !(c.Correct^this.state.Answers[i]))

        for(let S of AnswresStatus){
                Correct = Correct && S
        }

        this.setState({
            AnswresStatus: AnswresStatus,
            CheckAnswer: true
        })

        if(this.props.Object) {
            let QuestionsAnswers = this.props.Object.state.QuestionsAnswers
            let QuestionsAnswersFull = this.props.Object.state.QuestionsAnswersFull

            QuestionsAnswers[this.props.Object.state.CurrentIndex] = {
                Id: this.props.Question.Id,
                Answered: true,
                Score: Correct ? '1/1' : '0/1',
                Correct: Correct
            }


            QuestionsAnswersFull[this.props.Object.state.CurrentIndex] = this.state.Choices.filter((c,i) => this.state.Answers[i])

            this.props.Object.setState({
                QuestionsAnswers:QuestionsAnswers,
                QuestionsAnswersFull: QuestionsAnswersFull
            })

            
            
        }

        let SelectedChoices = this.state.Choices.filter((c,i) => this.state.Answers[i])

        this.props.PostPlayStatistic({
            QuestionId: this.props.Question.Id,
            Correct: Correct,
            Score: Correct ? '1/1' : '0/1',
            Key: this.props.Key,
            Player: this.props.Player,
            TotalTime: Math.trunc(0.001 * ((new Date()).getTime() - this.state.StartTime)),


            ChoicesId: SelectedChoices.map((c) => c.Id)

        })
    }

    AnswerStatusLine(){
        return(
            <div style = {{flexDirection:'row', display:'flex', alignContent:'center', alignItems:'center', 
            width: '100%'
            }}
            >
                <h6 
                style = {{
                    fontSize: responsiveFontSize(1),
                    color:this.state.AnswresStatus.includes(false) ? 'red': 'green',
                    textAlign:'center',
                    width:'100%'
                }}>
                    Your answer is<strong> {this.state.AnswresStatus.includes(false) ? ' NOT ' : ' '}correct</strong> 
                   
                </h6>
            </div>
            
        )
    }

    ChoiceBlock(c,width, index, ShowSolutions){

        let borderColor = '#b3b3b3'
        let textColor = "#b3b3b3"

        let choiceSelected = this.state.Answers[index]

        if(this.state.CheckAnswer && ShowSolutions)
        {
            borderColor = choiceSelected && c.Correct? "green" : borderColor
            borderColor = choiceSelected && !c.Correct? "red" : borderColor

            textColor = choiceSelected && c.Correct ? "green" : textColor
            textColor = choiceSelected && !c.Correct ? "red" : textColor
        } 
        else{
            borderColor = choiceSelected ? "#20A8D8" : '#b3b3b3'
            textColor = choiceSelected ? "#20A8D8" : "#b3b3b3"

        }

        
        return(
        <Col xs = {width}
        style = {{display:'block', overflow:'auto'}}
        key = {index} >
               <div 
                    onClick = {() => {
                        if(this.state.CheckAnswer){
                            return
                        }

                        let Answers = this.state.Answers
                        Answers[index] = !Answers[index]

                        this.setState({
                            Answers: Answers
                        })
                    }}
                    className={choiceSelected ? " bg-light" : ""}
                    style = {{cursor:this.state.CheckAnswer ? 'default' : 'pointer',
                        border: responsiveFontSize(0.1), borderStyle:'solid', borderColor: borderColor,
                        width:'100%',
                        flexDirection:'column', alignItems:'flex-start', alignContent:'flex-start'}}>
                            <div  style = {{flexDirection:'row', alignContent:'flex-start', alignItems:'flex-start', display:'flex',width:'100%', marginTop: responsiveHeight(0.5)}}>
                                <div
                                    style = {{width: responsiveWidth(1.5),
                                    height: responsiveWidth(1.5),
                                    marginLeft:responsiveHeight(0.5),
                                    marginRight:responsiveHeight(0.5),
                                    flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}
                                >
                                <h6 style = {{fontSize: responsiveFontSize(1), textAlign:'center', color:textColor}}>
                                    {index+1}
                                </h6>
                                </div>
                                <div 
                                    style = {{width:'100%'}}>
                                {c.Latex ?
                                    <SafeLatexViewComponent
                                        source= {c.Latex}
                                    />                                         
                                : <div/>}
                                {c.ImageURL ? 
                                    <img 
                                        style = {{height: responsiveHeight(25), objectFit:'contain',
                                         marginTop: (c.ImageURL && c.Latex) ? responsiveHeight(1) : 0}}
                                        src = {c.ImageURL}    
                                    />: <div/>}
                                </div>
                                <div style = {{width: responsiveWidth(1.5),
                                        height: responsiveWidth(1.5),
                                        marginLeft:responsiveHeight(0.5),
                                        marginRight:responsiveHeight(1),
                                        flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center'}}>
                                    {this.state.CheckAnswer&& ShowSolutions ? 
                                    (c.Correct ? 
                                        <h6 style = {{color:'green', fontSize: responsiveFontSize(1.0), textAlign:'right',width:'100%'}}>✔</h6>
                                        : 
                                        <h6 style = {{color:'red', fontSize: responsiveFontSize(1.0), textAlign:'right',width:'100%'}}>✘</h6>
                                        
                                        ) : <div/>}
                                </div>
                                
                            </div>
                            
                        </div>
 
                                 </Col>
        )
    }


    

}

//Constant
//
const QUESTION_SEARCHING_PARAMETER = 'IsPKQuestionSearching'

const QUESTION_DATA_PARAMETER = 'PKQuestion'

const QUESTION_GET_ERROR_PARAMETER = 'PKQuestionGetError'
//
const IVALUES_SEARCHING_PARAMETER = 'IsIIValuesSearching'
const IVALUES_DATA_PARAMETER = 'IIValues'
const IVALUES_GET_ERROR_PARAMETER = 'IIValuesGetError'
//
const QUESTION_STATISTIC_IS_ADDING_PARAMETER = 'QuestionStatisticIsAdding'
const QUESTION_STATISTIC_ERROR_ADD_PARAMETER = 'QuestionStatisticAddError'

function MapStateToProps(state) {
    return {

        IsQuestionSearching: state.Query[QUESTION_SEARCHING_PARAMETER],
        Question: state.Query[QUESTION_DATA_PARAMETER],
        GetQuestionError: state.Query[QUESTION_GET_ERROR_PARAMETER],
        Name: state.Authorization.name,
        
        Player: state.Authorization.student_key,

        InterpretationValues:state.Query[IVALUES_DATA_PARAMETER],
        IsValuesSearching: state.Query[IVALUES_SEARCHING_PARAMETER],
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetInfo: (Id) => {dispatch(GetListAttempt_ACTION(
           
            {
                SearchParameter: QUESTION_SEARCHING_PARAMETER,
                DataParameter: QUESTION_DATA_PARAMETER,
                GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
                Path: Routes.GetQuestionMultipleChoice,
    
                Value: Id,
    
                [QUESTION_SEARCHING_PARAMETER]: true,
                
                [QUESTION_DATA_PARAMETER]: {},
        
                [QUESTION_GET_ERROR_PARAMETER]: ''
            }
        ))},
        GetQuestion: (Id) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_SEARCHING_PARAMETER,
            DataParameter: QUESTION_DATA_PARAMETER,
            GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
            Path: Routes.GetQuestionKeyboard,

            Value: Id,

            [QUESTION_SEARCHING_PARAMETER]: true,
            
            [QUESTION_DATA_PARAMETER]: {},
    
            [QUESTION_GET_ERROR_PARAMETER]: ''
        }))},
        PostPlayStatistic: (Statistic) => {dispatch(AddObjectAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.PostStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:{
                ...Statistic
            }
        }))},
        PostPDFStatistic: (Statistic) => {dispatch(AddFileAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.AddQuestionPDFStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:Statistic
        }))}
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(MultipleChoiceQuestionPlayComponent)